import React from "react";
import PropTypes from "prop-types";
import { CreateMultiContainer } from "./ContainerMultiCreate";
import { getGenre, getGenrePopular } from "../api/getGenre";
import Spinner from "react-bootstrap/Spinner";

class GenreContainer extends React.Component {
  componentDidMount() {
    const { genreId } = this.props;
    this.props.request(genreId);
  }

  render = () => {
    const { data, loading, failure, render, genreId } = this.props;
    const genre = (data && data[0] && data[0].data) || [];
    const genrePopular = (data && data[1] && data[1].data) || [];
    if (loading) {
      return <Spinner animation="border" variant="secondary" />;
    }
    genre.id = parseInt(genreId, 10);
    return render({ genre, genrePopular, loading, failure });
  };
}

GenreContainer.propTypes = {
  genreId: PropTypes.string.isRequired,
};

export default CreateMultiContainer([getGenre, getGenrePopular], GenreContainer);
